import React, { useEffect, useRef, useState } from 'react';
import * as rsuite from 'rsuite';

import Layout from '../../Layout/PrivateLayout.js';
import * as General from '../General/General.js';
import { trackPromise } from 'react-promise-tracker';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import * as BiIcon from "react-icons/bi";
import {Modal} from "react-bootstrap";
import Delete from '../Delete/Delete.js';


const ProductGroupIndex = () => {

    //#region Const
    const toaster = rsuite.useToaster();
    let navigate = useNavigate();
    const DeleteRef = useRef()
    const [List, setList] = useState([]);
    const [PropertyList, setPropertyList] = useState([]);
    const [ParentId, setParentId] = useState(0);
    const [PhotoTag, setPhotoTag] = useState("");
    const [Type, setType] = useState(0);
    const [PropertyPermission, setPropertyPermission] = useState(false);
    const [Id, setId] = useState(0);
    const [Title, setTitle] = useState('');
    const [ParentTitle, setParentTitle] = useState('');
    const [WebIsActive, setWebIsActive] = useState(true);
    const [IsActive, setIsActive] = useState(true);
    const [ShowModal, setShowModal] = React.useState(false);
    const [ShowPropertyModal, setShowPropertyModal] = React.useState(false);
    const [sortColumn, setSortColumn] = React.useState();
    const [sortType, setSortType] = React.useState();
    const [loading, setLoading] = React.useState(false)
    //*********************************************** */
    const [PhotoList, setPhotoList] = React.useState([]);
    const [IsBanner, setIsBanner] = React.useState(0);
    const [IsMain, setIsMain] = React.useState(0);
    const [Order, setOrder] = useState(1);
    const [PhotoIndex, setPhotoIndex] = useState(-1);
    const [PhotoId, setPhotoId] = useState(0);
    const [Image, setImage] = useState({ preview: "", raw: "" });


    //#endregion

    const ImageChange = e => {
        if (e.target.files.length) {
            setImage({
                preview: URL.createObjectURL(e.target.files[0]),
                raw: e.target.files[0]
            });
        }
    };


    //#region Methods

    const Search = () => {
        trackPromise(
            fetch(General.ApiRoute() + '/ProductGroup/Search', {
                method: 'Get',
                headers: {
                    'ApiKey': General.APIKey(),
                    'WebIsActive': -1,
                    'IsActive': -1
                },
                credentials: 'include'
            })
                .then(res => res.json())
                .then(result => {
                    var tmp = []
                    for (var i = 0; i < result.length; i++) {
                        tmp.push({
                            row: result[i].row,
                            id: result[i].id,
                            title: result[i].title,
                            isActive: result[i].isActive,
                            webIsActive: result[i].webIsActive,
                            parentId: result[i].parentId,
                            identityNo: result[i].identityNo,
                            type: result[i].type,
                            photoCount: result[i].photoCount,
                            photoTag: result[i].photoTag,
                            children: result[i].children,

                        })
                    }
                    setList(tmp)
                })
        )
    }




    const ResetTotal = () => {
        setParentTitle("");
        setParentId(0);
        setTitle("");
        setId(0);
        setWebIsActive(true);
        setIsActive(true);
        setPhotoTag("");
        setIsBanner(0);
        setIsMain(0);
        setOrder(0);
        setImage({ preview: "", raw: "" });
        setPhotoList([]);
        setPhotoIndex(-1);
        setPhotoId(0);
    }

    const ResetForInsert = () => {
        setTitle("");
        setId(0);
        setImage({ preview: "", raw: "" });
        setWebIsActive(true);
        setIsActive(true);
        setPhotoTag("");
        setIsBanner(0);
        setIsMain(0);
        setOrder(0);
        setPhotoList([]);
    }
    const ResetPhoto = () => {
        setIsBanner(0);
        setIsMain(0);
        setImage({ preview: "", raw: "" });
        setOrder(Order * 1 + 1);
        setPhotoId(0);
        setPhotoIndex(-1)
    }

    const Save = () => {
        if (Title == "") {
            toaster.push(General.ShowMessage('error', General.ErrorMessage("عنوان اجباری می باشد")), 'topCenter')
            return;
        }
        if (Type == "-1") {
            toaster.push(General.ShowMessage('error', General.ErrorMessage("نوع اجباری می باشد")), 'topCenter')
            return;
        }
        var f_data = new FormData();
        f_data.append("Id", Id);
        f_data.append("Title", Title);
        f_data.append("Type", Type);
        f_data.append("WebIsActive", WebIsActive ? 1 : 0);
        f_data.append("IsActive", IsActive ? 1 : 0);
        f_data.append("ParentId", ParentId);
        f_data.append("PhotoTag", PhotoTag);

        console.dir(PhotoList)
        for (let index = 0; index < PhotoList.length; index++) {
            f_data.append("Photos[" + index + "].PhotoTag", PhotoTag);
            f_data.append("Photos[" + index + "].Order", PhotoList[index].Order * 1);
            f_data.append("Photos[" + index + "].Id", PhotoList[index].Id);
            f_data.append("Photos[" + index + "].IsMain", PhotoList[index].IsMain);
            f_data.append("Photos[" + index + "].IsBanner", PhotoList[index].IsBanner);
            f_data.append("Photos[" + index + "].Image", PhotoList[index].Image.raw);
            f_data.append("Photos[" + index + "].ProductGroupId", Id);
        };
        console.dir(f_data)
        var RequestOptions = {
            method: "post",
            withCredentials: true,
            headers: {
                'ApiKey': General.APIKey(),
                'content-type': 'multipart/form-data'
            }

        }

        trackPromise(
            axios.post(General.ApiRoute() + "/ProductGroup/Save", f_data, RequestOptions)
                .then(function (result) {
                    if (result.data == "OK") {
                        toaster.push(General.ShowMessage('success', General.SuccessMessage("ذخیزه شده است")), 'topCenter')

                        Search();
                        if (Id != 0) {

                            setShowModal(false);
                            ResetTotal();
                        }
                        else
                            ResetForInsert()
                    }
                    else {
                        toaster.push(General.ShowMessage('error', General.ErrorMessage(result.data)), 'topCenter')

                    }

                }).catch((error) => {
                    console.dir(error)
                    toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')

                })
        )
        // var RequestOptions = {
        //     data: {
        //         "Id": Id,
        //         "Title": Title,
        //         "Type": Type,
        //         "ParentId": ParentId,
        //         "WebIsActive": WebIsActive ? 1 : 0,
        //         "IsActive": IsActive ? 1 : 0,
        //         "Photos": PhotoList
        //     },
        //     url: General.ApiRoute() + "/ProductGroup/Save",
        //     method: "post",
        //     withCredentials: true,

        //     headers: {
        //         'ApiKey': General.APIKey(),
        //         'Content-Type': 'application/json'
        //     }
        // }


        // trackPromise(
        //     axios(RequestOptions)
        //         .then(function (result) {
        //             if (result.data == "OK") {
        //                 toaster.push(General.ShowMessage('success', General.SuccessMessage("ذخیزه شده است")), 'topCenter')

        //                 Search();
        //                 if (Id != 0) {

        //                     setShowModal(false);
        //                     ResetTotal();
        //                 }
        //                 else
        //                     ResetForInsert()
        //             }
        //             else {
        //                 toaster.push(General.ShowMessage('error', General.ErrorMessage(result.data)), 'topCenter')

        //             }
        //         }).catch((error) => {
        //             toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')

        //         })
        // )
    }


    const SavePhoto = () => {

        var photoTemp = [...PhotoList];
        // var index = photoTemp.findIndex(x => x.Row == row);

        if (Id != 0) {
            var f_data = new FormData();
            f_data.append("PhotoTag", PhotoTag);
            f_data.append("Order", Order);
            f_data.append("Id", PhotoId);
            f_data.append("IsMain", IsMain ? 1 : 0);
            f_data.append("IsBanner", IsBanner ? 1 : 0);
            f_data.append("Image", Image.raw);
            f_data.append("ProductGroupId", Id);
            var RequestOptions = {
                method: "post",
                withCredentials: true,
                headers: {
                    'ApiKey': General.APIKey(),
                    'content-type': 'multipart/form-data'
                }

            }

            trackPromise(
                axios.post(General.ApiRoute() + "/ProductGroup/SavePhoto", f_data, RequestOptions)
                    .then(function (result) {
                        if (result.data == "OK") {
                            toaster.push(General.ShowMessage('success', General.SuccessMessage("ذخیزه شده است")), 'topCenter')
                            GetPhoto(Id);
                            ResetPhoto();
                        }
                        else {
                            toaster.push(General.ShowMessage('error', General.ErrorMessage(result.data)), 'topCenter')

                        }
                    }).catch((error) => {
                        toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')

                    })
            )
        }
        else {
            if (PhotoIndex == -1) {
                photoTemp.push({
                    Row: photoTemp.length + 1,
                    Id: 0,
                    IsBanner: IsBanner ? 1 : 0,
                    IsMain: IsMain ? 1 : 0,
                    Order: Order,
                    Image: Image,

                })

            }
            else {
                photoTemp[PhotoIndex].IsBanner(IsBanner ? 1 : 0);
                photoTemp[PhotoIndex].IsMain(IsMain ? 1 : 0);
                photoTemp[PhotoIndex].Order(Order);
                photoTemp[PhotoIndex].Image(Image)

            }
            ResetPhoto();
            setPhotoList(photoTemp);
        }

    }


    const EditPhoto = (id, row) => {
        var photoTemp = [...PhotoList];
        var index = photoTemp.findIndex(x => x.Row == row);
        setPhotoIndex(index);
        setPhotoId(photoTemp[index].Id);
        setIsBanner(photoTemp[index].IsBanner);
        setIsMain(photoTemp[index].IsMain);
        setOrder(photoTemp[index].Order);
        setImage(photoTemp[index].Image)

    }

    const DeletePhoto = (id , row) => {
        var photoTemp = [...PhotoList];
        var index = photoTemp.findIndex(x => x.Row == row);

        if (Id != 0) {
            var RequestOptions = {
                data: {
                    "Id": photoTemp[index].Id,
                    "ProductGroupId": Id,
                },
                url: General.ApiRoute() + "/ProductGroup/DeletePhoto",
                method: "post",
                withCredentials: true,

                headers: {
                    'ApiKey': General.APIKey(),
                    'Content-Type': 'application/json'
                }
            }
            trackPromise(
                axios(RequestOptions)
                    .then(function (result) {
                        if (result.data == "OK") {
                            toaster.push(General.ShowMessage('success', General.SuccessMessage("حذف شده است")), 'topCenter')
                            // GetPhoto(Id);
                            photoTemp.splice(index, 1);
                            setPhotoList(photoTemp);
                        }
                        else {
                            toaster.push(General.ShowMessage('error', General.ErrorMessage(result.data)), 'topCenter')

                        }
                    }).catch((error) => {
                        toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')

                    })
            )

        }
        else {
            photoTemp.splice(index, 1);
            setPhotoList(photoTemp);
        }

    }



    const ShowDelete = (id, title) => {
        DeleteRef.current.Get(4, id, title);
    }

    const ShowEdit = (Id) => {
        ResetTotal();
        setId(Id);
        setShowModal(true);
        trackPromise(
            fetch(General.ApiRoute() + '/ProductGroup/GetById', {
                method: 'Get',
                headers: {
                    'ApiKey': General.APIKey(),
                    'Id': Id
                },
                credentials: 'include'
            })
                .then(res => res.json())
                .then(result => {
                    setTitle(result.title);
                    setParentId(result.parentId);
                    setParentTitle(result.parentTitle)
                    setPhotoTag(result.photoTag)
                    setWebIsActive(result.webIsActive == 0 ? false : true);
                    setIsActive(result.isActive == 0 ? false : true);
                    setType(result.type)
                    GetPhoto(result.id)
                })
        )
    }


    const GetPhoto = (id) => {
        trackPromise(
            fetch(General.ApiRoute() + '/ProductGroup/GetByProductGroupIdPhoto', {
                method: 'Get',
                headers: {
                    'ApiKey': General.APIKey(),
                    'ProductGroupId': id
                },
                credentials: 'include'
            })
                .then(res => res.json())
                .then(result => {
                    var tmp = []
                    for (var i = 0; i < result.length; i++) {
                        tmp.push({
                            Row: i + 1,
                            Id: result[i].id,
                            IsBanner: result[i].isBanner,
                            IsMain: result[i].isMain,
                            Order: result[i].order,
                            Image: General.ApiPhotoRoute() + 'Content/Images/Product/Group/' + result[i].photoTag + "" + result[i].id + "_Img.jpg",

                        })
                    }
                    console.dir(tmp)
                    setPhotoList(tmp)
                })
        )
    }

    const ShowNew = (parentId, parentTitle, type, photoTag) => {
        ResetTotal();
        setShowModal(true);
        setParentId(parentId);
        setParentTitle(parentTitle);
        setPhotoTag(photoTag);
        setType(type)
    }

    const ShowProperty = (id, parentId, Title) => {
        setParentTitle(Title)
        setShowPropertyModal(true);
        setId(id);
        setParentId(parentId)
        SearchProperty(id, parentId);


    }

    const SearchProperty = (id, parentId, OnSave = false) => {
        setPropertyList([]);
        trackPromise(
            fetch(General.ApiRoute() + '/ProductGroupProperty/GetForInsert', {
                method: 'Get',
                headers: {
                    'ApiKey': General.APIKey(),
                    'GroupId': id,
                    'ParentGroupId': parentId
                },
                credentials: 'include'
            })
                .then(res => res.json())
                .then(result => {
                    var tmp = []
                    for (var i = 0; i < result.length; i++) {
                        tmp.push({
                            row: i + 1,
                            Id: result[i].id,
                            Title: result[i].title,
                            Editable: result[i].editable,
                            GroupId: result[i].groupId,
                            IsActive: result[i].isActive,
                            Order: result[i].order,
                            ForParent: result[i].forParent,
                            status: null,
                            IsActiveComment: result[i].isActive == 1 ? "فعال" : "غیر فعال"

                        })
                    }
                    if (OnSave) {
                        tmp.push({
                            row: tmp.length + 1,
                            IsActive: 1,
                            Title: '',
                            Editable: true,
                            ForParent: false,
                            Id: General.GuidEmpty(),
                            status: "EDIT",
                            IsActiveComment: "فعال",
                            GroupId: Id,
                            Order: [...tmp].filter(o => o.ForParent == false).length > 0 ?
                                Math.trunc(Math.max(...tmp.filter(o => o.ForParent == false).map(o => o.Order))) + 1 : 1,
                        })
                    }
                    setPropertyList(tmp)
                })
        )
    }

    const onEditProperty = (row) => {
        var temp = [...PropertyList];
        var index = temp.findIndex(x => x.row == row);
        if (index != -1) {
            temp[index].status = "EDIT";
        }
        setPropertyList(temp);
    }

    const onChangeProperty = (row, dataType, value) => {
        var temp = [...PropertyList];
        var index = temp.findIndex(x => x.row == row);
        if (index != -1) {
            if (dataType == "string")
                temp[index].Title = value;
            else if (dataType == "CheckBox")
                temp[index].IsActive = value;
            else if (dataType == "number")
                temp[index].Order = value;

        }
        setPropertyList(temp);
    }

    const SaveProperty = (id, title, groupId, isActive, order) => {

        if (title == "") {
            toaster.push(General.ShowMessage('error', General.ErrorMessage("عنوان اجباری می باشد")), 'topCenter')
            return;
        }
        var RequestOptions = {
            data: {
                "Id": id,
                "Title": title,
                "GroupId": groupId,
                "IsActive": isActive,
                "Order": order
            },
            url: General.ApiRoute() + "/ProductGroupProperty/Save",
            method: "post",
            withCredentials: true,

            headers: {
                'ApiKey': General.APIKey(),
                'Content-Type': 'application/json'
            }
        }


        trackPromise(
            axios(RequestOptions)
                .then(function (result) {
                    if (result.data == "OK") {
                        toaster.push(General.ShowMessage('success', General.SuccessMessage("ذخیزه شده است")), 'topCenter')
                        SearchProperty(Id, ParentId, true);
                    }
                    else {
                        toaster.push(General.ShowMessage('error', General.ErrorMessage(result.data)), 'topCenter')

                    }
                }).catch((error) => {
                    toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')

                })
        )

    }

    const DeleteProperty = (id, title, row) => {

        if (id != General.GuidEmpty()) {
            var RequestOptions = {
                data: {
                    "Id": id,
                    "Title": title,
                    "GroupId": Id
                },
                url: General.ApiRoute() + "/ProductGroupProperty/UpdateIsDeleted",
                method: "post",
                withCredentials: true,

                headers: {
                    'ApiKey': General.APIKey(),
                    'Content-Type': 'application/json'
                }
            }


            trackPromise(
                axios(RequestOptions)
                    .then(function (result) {
                        if (result.data == "OK") {
                            toaster.push(General.ShowMessage('success', General.SuccessMessage("حذف شده است")), 'topCenter')
                            SearchProperty(Id, ParentId);
                        }
                        else {
                            toaster.push(General.ShowMessage('error', General.ErrorMessage(result.data)), 'topCenter')

                        }
                    }).catch((error) => {
                        toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')

                    })
            )
        }
        else {
            var temp = [...PropertyList.filter(item => item.row !== row)];
            console.dir(temp);
            setPropertyList(temp);
        }



    }

    const CheckPermission = () => {
        var myHeaders = new Headers();
        myHeaders.append("ApiKey", General.APIKey());
        myHeaders.append("Page", 4);
        myHeaders.append("Operation", 0);

        var requestOptions = {
            method: "Get",
            headers: myHeaders,
            credentials: 'include'

        };
        trackPromise(
            fetch(General.ApiRoute() + "/Common/CheckPermission", requestOptions)
                .then(response => response.text())
                .then(result => {
                    if (result.toString() != "OK") {
                        navigate("/AccessDenied");
                    }
                    else {
                        CheckPropertyPermission();
                        Search();

                    }
                }).catch((error) => {
                    toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')
                })
        )
    }

    const CheckPropertyPermission = () => {
        var myHeaders = new Headers();
        myHeaders.append("ApiKey", General.APIKey());
        myHeaders.append("Page", 7);
        myHeaders.append("Operation", 0);

        var requestOptions = {
            method: "Get",
            headers: myHeaders,
            credentials: 'include'

        };
        trackPromise(
            fetch(General.ApiRoute() + "/Common/CheckPermission", requestOptions)
                .then(response => response.text())
                .then(result => {
                    if (result.toString() != "OK") {
                        setPropertyPermission(false);
                    }
                    else {
                        setPropertyPermission(true);

                    }
                }).catch((error) => {
                    toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')
                })
        )
    }



    useEffect(() => {
        CheckPermission();
        document.title = "تعریف گروه بندی محصولات ";
    }, [])
    //#endregion







    return (

        <Layout title="گروه بندی محصولات">


            <div className="h-100 p-1">
                <rsuite.Panel className="bg-white ">
                    <rsuite.Grid fluid>
                        <rsuite.Row>

                            <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} className="text-left" >
                                <rsuite.Button appearance="primary" color="green" size="xs" className="m-1" onClick={() => ShowNew(0, "")}>  جـــدید</rsuite.Button>
                            </rsuite.Col>
                        </rsuite.Row>
                    </rsuite.Grid>
                    <hr />
                    <div className="h-90 p-0">
                        <div className="h-100-y p-0">

                            <rsuite.Panel className="bg-white mt-2 p-0">

                                <rsuite.Table
                                    isTree
                                    rowKey='id'
                                    height={List.length>20 ? List.length*50 : 560}
                                    data={List}
                                    wordWrap="break-word"
                                    loading={loading}
                                // className='h-100-y'


                                >
                                    <rsuite.Table.Column flexGrow={1} align="center" fixed >
                                        <rsuite.Table.HeaderCell>#</rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell dataKey="row" />
                                    </rsuite.Table.Column>

                                    <rsuite.Table.Column flexGrow={5} fixed resizable>
                                        <rsuite.Table.HeaderCell>عنوان</rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell dataKey="title" />
                                    </rsuite.Table.Column>
                                    <rsuite.Table.Column flexGrow={5} fixed resizable>
                                        <rsuite.Table.HeaderCell>نوع</rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell>
                                            {(rowData) => {
                                                return <>

                                                    {rowData.type == 0 ?

                                                        <>هیچکدام</>
                                                        : rowData.type == 1 ?

                                                            <>دارای توان (KW) و جریان (A) </>
                                                            : rowData.type == 2 ?

                                                                <> دارای توان (KW)  </>
                                                                : rowData.type == 3 ?

                                                                    <> دارای جریان (A)</>
                                                                    :
                                                                    <></>
                                                    }
                                                </>

                                            }}
                                        </rsuite.Table.Cell>
                                    </rsuite.Table.Column>
                                    <rsuite.Table.Column fullText flexGrow={1} resizable>
                                        <rsuite.Table.HeaderCell>شناسه</rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell dataKey="identityNo" />
                                    </rsuite.Table.Column>
                                    <rsuite.Table.Column fullText flexGrow={1} resizable>
                                        <rsuite.Table.HeaderCell>تعداد تصویر  </rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell dataKey="photoCount" />
                                    </rsuite.Table.Column>
                                    <rsuite.Table.Column fullText flexGrow={1} resizable>
                                        <rsuite.Table.HeaderCell>فعال   </rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell>
                                            {(rowData) => {
                                                return <>

                                                    {rowData.isActive == 1 ?

                                                        <BiIcon.BiCheckCircle className="text-success fs-6" />
                                                        :
                                                        <BiIcon.BiXCircle className="text-danger fs-6" />
                                                    }
                                                </>


                                            }}

                                        </rsuite.Table.Cell>
                                    </rsuite.Table.Column>
                                    <rsuite.Table.Column fullText flexGrow={2} resizable>
                                        <rsuite.Table.HeaderCell>فعال در وب سایت</rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell>
                                            {(rowData) => {
                                                return <>

                                                    {rowData.webIsActive == 1 ?

                                                        <BiIcon.BiCheckCircle className="text-success fs-6" />
                                                        :
                                                        <BiIcon.BiXCircle className="text-danger fs-6" />
                                                    }
                                                </>

                                            }}

                                        </rsuite.Table.Cell>
                                    </rsuite.Table.Column>

                                    <rsuite.Table.Column fixed="right" flexGrow={1} >
                                        <rsuite.Table.HeaderCell></rsuite.Table.HeaderCell>

                                        <rsuite.Table.Cell>
                                            {(rowData) => {
                                                return <>
                                                    <rsuite.Whisper placement="autoVerticalStart" trigger="click" speaker={
                                                        <rsuite.Popover full className='PopoverMenu'>
                                                            <rsuite.Dropdown.Menu  >
                                                                <rsuite.Dropdown.Item onClick={() => ShowEdit(rowData.id)}>ویرایش</rsuite.Dropdown.Item>
                                                                <rsuite.Dropdown.Item className={rowData.children == null || rowData.children.length == 0 ? '' : "hide"} onClick={() => ShowDelete(rowData.id, rowData.title)}>حذف</rsuite.Dropdown.Item>
                                                                <rsuite.Dropdown.Item className={rowData.parentId != 0 ? 'hide' : ""} onClick={() => ShowNew(rowData.id, rowData.title, rowData.type)}>تعریف زیر گروه</rsuite.Dropdown.Item>
                                                                <rsuite.Dropdown.Item className={PropertyPermission ? '' : "hide"} onClick={() => ShowProperty(rowData.id, rowData.parentId, rowData.title)}>تعریف مشخصات گروه</rsuite.Dropdown.Item>


                                                            </rsuite.Dropdown.Menu>
                                                        </rsuite.Popover>
                                                    }>
                                                        <rsuite.IconButton appearance="subtle" icon={<BiIcon.BiDotsHorizontalRounded />} />
                                                    </rsuite.Whisper>
                                                </>
                                            }}
                                        </rsuite.Table.Cell>

                                    </rsuite.Table.Column>
                                </rsuite.Table>

                            </rsuite.Panel>

                        </div>
                    </div>

                </rsuite.Panel >
            </div >




            <Modal show={ShowModal} onHide={() => setShowModal(false)} size="xl" backdrop="static" keyboard={false}>
                <Modal.Header >

                    <Modal.Title className='fs-5'>{ParentId == 0 ? <b>تعریف گروه محصول</b> : <b>تعریف زیر گروه  :  {ParentTitle}</b>}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <rsuite.Grid fluid>
                        <rsuite.Row className="p-1">
                            <rsuite.Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                <rsuite.Row className="p-1">
                                    <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                        <BiIcon.BiSolidStar className={Title == "" ? 'text-danger' : 'hide'} />  <label>عنوان</label>
                                        <rsuite.Input value={Title} onChange={(e) => (setTitle(e), setPhotoTag(e))} />
                                    </rsuite.Col>
                                    <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                        <BiIcon.BiSolidStar disabled={Id != 0 ? true : false} className={PhotoTag == "" ? 'text-danger' : 'hide'} />  <label>عنوان معرفی تصویر </label>
                                        <rsuite.Input value={PhotoTag} onChange={(e) => setPhotoTag(e)} />
                                    </rsuite.Col>
                                    <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                        <BiIcon.BiSolidStar className={Title == "" ? 'text-danger' : 'hide'} />  <label>نوع</label>
                                        <select disabled={(ParentId != 0 && ParentId != -1) || (Id != 0 && Id != -1) ? true : false} className="rs-input" onChange={(e) => setType(e.target.value)} value={Type}>
                                            <option value="-1">انتخاب نمایید</option>
                                            <option value="0">هیچکدام </option>
                                            <option value="1">دارای توان (KW) و جریان (A)  </option>
                                            <option value="2">دارای توان (KW)   </option>
                                            <option value="2">دارای جریان (A)   </option>
                                        </select>
                                    </rsuite.Col>
                                    <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                        <rsuite.Checkbox onChange={(e, checked) => setIsActive(checked)} checked={IsActive} value={IsActive} /> &nbsp;   فعال می باشد
                                    </rsuite.Col>
                                    <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                        <rsuite.Checkbox onChange={(e, checked) => setWebIsActive(checked)} checked={WebIsActive} value={WebIsActive} /> &nbsp;  در وب سایت فعال می باشد
                                    </rsuite.Col>
                                </rsuite.Row>
                            </rsuite.Col>
                            <rsuite.Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                <rsuite.Row className="p-1">
                                    <rsuite.Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                                        <rsuite.Row>

                                            <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>

                                                <BiIcon.BiSolidStar className={Order == "" ? 'text-danger' : 'hide'} />  <label>ترتیب نمایش</label>
                                                <rsuite.Input value={Order} onChange={(e) => setOrder(e)} />
                                            </rsuite.Col>
                                            <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                                <rsuite.Checkbox onChange={(e, checked) => setIsMain(checked)} checked={IsMain} value={IsMain} /> &nbsp; تصویر اصلی می باشد

                                            </rsuite.Col>
                                            <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                                <rsuite.Checkbox onChange={(e, checked) => setIsBanner(checked)} checked={IsBanner} value={IsBanner} /> &nbsp; تصویر بنر می باشد

                                            </rsuite.Col>
                                            <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                                <rsuite.Button size='xs' block color="green" appearance="primary" onClick={() => SavePhoto()}>
                                                    اضافه شدن تصویر
                                                </rsuite.Button>
                                            </rsuite.Col>

                                        </rsuite.Row>

                                    </rsuite.Col>

                                    <rsuite.Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12} className='text-center'>

                                        <label htmlFor="upload-button">
                                            {Image.preview ? (
                                                <div className='ProductPic bg-white shadow-sm rounded d-flex align-items-center justify-content-center '>
                                                    <img src={Image.preview} alt="dummy" className='ProductPic' />
                                                </div>
                                            ) : (

                                                <div className='ProductPic bg-gray rounded shadow-sm  align-items-center justify-content-center pt-5'>
                                                    <BiIcon.BiCamera className='fs-3'></BiIcon.BiCamera>
                                                    <br />
                                                    <div className="text-center ّ Cursor">  به منظور انتخاب تصویر (.jpg) کلیک کنید</div>
                                                    <div className="text-center ّ Cursor">  180*240</div>
                                                </div>
                                            )}
                                        </label>
                                        <input
                                            type="file"
                                            id="upload-button"
                                            style={{ display: "none" }}
                                            onChange={ImageChange}
                                            accept="image/jpg"
                                        />


                                    </rsuite.Col>



                                </rsuite.Row>
                            </rsuite.Col>
                        </rsuite.Row>
                        <rsuite.Row className='mt-3'>
                            {PhotoList.map((photo) =>
                                <rsuite.Col xxl={6} xl={6} lg={8} md={12} sm={12} xs={24} className='text-center'>

                                    <rsuite.Panel shaded bordered bodyFill className={photo.IsMain == 1 && photo.IsBanner == 0 ? "border-success" : photo.IsBanner == 1 && photo.IsMain == 0 ? "border-warning" : photo.IsMain == 1 && photo.IsBanner == 1 ? "border-primary" : ""} style={{ display: 'inline-block', width: 240 }}>
                                        <img src={photo.Image} height="180" />
                                        <rsuite.Panel className='text-start'>

                                            <rsuite.Button size='xs' color="light" appearance="primary" onClick={() => EditPhoto(photo.Id, photo.Row)}>
                                                ویرایش
                                            </rsuite.Button>
                                            <rsuite.Button size='xs' color="red" appearance="primary" onClick={() => DeletePhoto(photo.Id, photo.Row)}>
                                                حذف
                                            </rsuite.Button>
                                        </rsuite.Panel>
                                    </rsuite.Panel>


                                </rsuite.Col>
                            )}


                        </rsuite.Row>


                    </rsuite.Grid>
                </Modal.Body>
                <Modal.Footer>
                    <rsuite.Button appearance="primary" color="green" onClick={Save}>
                        ذخیره
                    </rsuite.Button>
                    <rsuite.Button appearance="subtle" onClick={() => setShowModal(false)}>
                        بستن
                    </rsuite.Button>

                </Modal.Footer>
            </Modal>

            <Modal show={ShowPropertyModal} onHide={() => setShowPropertyModal(false)} size="xl" scrollable backdrop="static" keyboard={false}>
                <Modal.Header >

                    <Modal.Title className='fs-5'><b> {ParentTitle}</b></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <rsuite.Grid fluid>
                        <rsuite.Row className="p-1">
                            <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                <rsuite.Button appearance="primary" color="green"
                                    onClick={() => {
                                        setPropertyList([
                                            ...PropertyList,
                                            {
                                                row: PropertyList.length + 1, IsActive: 1, Title: '', Editable: true, Id: General.GuidEmpty(), status: "EDIT",
                                                IsActiveComment: "فعال", GroupId: Id,
                                                Order: [...PropertyList].filter(o => o.ForParent == false).length > 0 ?
                                                    Math.trunc(Math.max(...PropertyList.filter(o => o.ForParent == false).map(o => o.Order))) + 1 : 1, ForParent: false
                                            }

                                        ]);
                                    }}
                                >
                                    اضافه شدن مشخصات جدید
                                </rsuite.Button>
                            </rsuite.Col>
                            <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>


                                <rsuite.Table height={420} data={PropertyList}>
                                    <rsuite.Table.Column className="w-10p" align="center"  >
                                        <rsuite.Table.HeaderCell>#</rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell dataKey="row">
                                        </rsuite.Table.Cell>
                                    </rsuite.Table.Column>
                                    <rsuite.Table.Column flexGrow={1} fullText resizable>
                                        <rsuite.Table.HeaderCell>عنوان</rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell  >

                                            {(rowData) => {
                                                return <>

                                                    {rowData.status == 'EDIT' ? (
                                                        <rsuite.Input
                                                            defaultValue={rowData.Title}
                                                            onChange={value => {
                                                                onChangeProperty?.(rowData.row, "string", value);
                                                            }}
                                                        />
                                                    ) : (
                                                        <text className={!rowData.ForParent ? '' : "text-black-50"}>

                                                            {rowData.Title}
                                                        </text>
                                                    )}
                                                </>
                                            }}

                                        </rsuite.Table.Cell>



                                    </rsuite.Table.Column>

                                    <rsuite.Table.Column width={100} flexGrow={1} fullText resizable>
                                        <rsuite.Table.HeaderCell>ترتیب نمایش</rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell  >

                                            {(rowData) => {
                                                return <>

                                                    {rowData.status == 'EDIT' ? (
                                                        <rsuite.Input
                                                            defaultValue={rowData.Order}
                                                            onChange={value => {
                                                                onChangeProperty?.(rowData.row, "number", value);
                                                            }}
                                                        />
                                                    ) : (
                                                        <text className={!rowData.ForParent ? '' : "text-black-50"}>

                                                            {rowData.Order}
                                                        </text>
                                                    )}
                                                </>
                                            }}

                                        </rsuite.Table.Cell>



                                    </rsuite.Table.Column>


                                    <rsuite.Table.Column width={100} >
                                        <rsuite.Table.HeaderCell>وضعیت</rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell  >
                                            {(rowData) => {
                                                return <>

                                                    {rowData.status == 'EDIT' ? (

                                                        <select className="rs-input" onChange={(e) => onChangeProperty(rowData.row, "CheckBox", e.target.value)} value={rowData.IsActive}>
                                                            <option value="0">غیر فعال </option>
                                                            <option value="1">فعال </option>
                                                        </select>
                                                    ) : (
                                                        <text className={!rowData.ForParent ? '' : "text-black-50"}>

                                                            {rowData.IsActiveComment}
                                                        </text>
                                                    )}
                                                </>
                                            }}

                                        </rsuite.Table.Cell>
                                    </rsuite.Table.Column>



                                    <rsuite.Table.Column width={100} fixed='right'>
                                        <rsuite.Table.HeaderCell></rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell>
                                            {(rowData) => {
                                                return <>
                                                    {rowData.Editable ?
                                                        !rowData.ForParent ?
                                                            <>

                                                                {rowData.status != "EDIT" ? <BiIcon.BiEditAlt onClick={() => onEditProperty(rowData.row)} className='fs-6 Cursor' />
                                                                    :
                                                                    <BiIcon.BiSave onClick={() => SaveProperty(rowData.Id, rowData.Title, rowData.GroupId, rowData.IsActive, rowData.Order)} className='fs-6 text-success Cursor' />
                                                                }
                                                                &nbsp;&nbsp;&nbsp;
                                                                <BiIcon.BiTrash onClick={() => DeleteProperty(rowData.Id, rowData.Title, rowData.row)} className='fs-6 text-danger Cursor' />
                                                            </>
                                                            :
                                                            <BiIcon.BiSave onClick={() => SaveProperty(rowData.Id, rowData.Title, rowData.GroupId, rowData.IsActive, rowData.Order)} className='fs-6 text-success Cursor' />




                                                        :
                                                        <></>
                                                    }
                                                </>
                                            }}
                                        </rsuite.Table.Cell>
                                    </rsuite.Table.Column>
                                </rsuite.Table>



                            </rsuite.Col>



                        </rsuite.Row>

                    </rsuite.Grid>
                </Modal.Body>
                <Modal.Footer>
                    {/* <rsuite.Button appearance="primary" color="green" onClick={Save}>
                        ذخیره
                    </rsuite.Button> */}
                    <rsuite.Button appearance="subtle" onClick={() => setShowPropertyModal(false)}>
                        بستن
                    </rsuite.Button>

                </Modal.Footer>
            </Modal>



            <Delete ref={DeleteRef} onSubmit={Search} />
        </Layout >


    )
}

export default ProductGroupIndex;